export default __webpack_public_path__ + "static/media/Tornhill.0376fd8d.mp4";